/* eslint-disable react-hooks/exhaustive-deps */
import Container from "@mui/material/Container";
import useStyles from "./style";

import { useEffect, useMemo, useRef } from "react";
import { useLocation } from "react-router";
import Banner from "./components/Banner";
import Footer from "./components/Footer";

const MainLayout = ({ children, preOrderAction }: any): JSX.Element => {
  const classes = useStyles();

  const paperRef = useRef<any>(null);
  const bannerRef = useRef<any>(null);
  const location = useLocation();

  useEffect((): any => {
    if (location.pathname !== "/") {
      if (paperRef?.current?.offsetTop) {
        setTimeout(() => {
          window.scrollTo({
            behavior: "smooth",
            top: paperRef?.current?.offsetTop - 50,
          });
        }, 100);
      }
    } else {
      if (bannerRef?.current) {
        setTimeout(() => {
          window.scrollTo({
            behavior: "smooth",
            top: bannerRef?.current?.offsetTop,
          });
        }, 100);
      }
    }
  }, [location.pathname]);

  const paperStyles = useMemo(() => {
    if (location.pathname === "/shopping-cart") {
      return "";
    }
    return classes.paperMinHeight;
  }, [location.pathname]);

  return (
    <>
      <div className={classes.mainLayoutContainer}>
        <Banner bannerRef={bannerRef} />
        <div className={classes.card}>
          {/* /Main Layout Children */}
          <Container className={classes.container}>
            <div className={`${classes.paper} ${paperStyles}`} ref={paperRef}>
              {children}
            </div>
          </Container>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default MainLayout;
